if (!customElements.get('bmw-image-carousel')) {
  customElements.define('bmw-image-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.track = this.querySelector('.bmw-slides');
      this.navigation = this.querySelector('.bmw-carousel-navigation');
      this.segments = this.querySelector('.bmw-segments');
      this.desktop = matchMedia('(min-width: 768px)');
      this.desktop.addEventListener('change', () => this.go(this.index), options);
      this.index = 0;
      this.rebuild();
      this.track.addEventListener('scroll', () => this.sync(), {...options, passive: true});
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.dataset.index !== undefined) this.go(Number(button.dataset.index));
        else if (button.dataset.direction) this.go(this.index + Number(button.dataset.direction));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (this.desktop.matches) return;
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index);
      }, options);
      this.resize = new ResizeObserver(() => this.go(this.index));
      this.resize.observe(this.track);
      this.mutations = new MutationObserver(() => this.rebuild());
      this.mutations.observe(this.track, {childList: true});
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.resize?.disconnect();
      this.mutations?.disconnect();
      this.controller = null;
    }
    rebuild() {
      this.slides = Array.from(this.track.children);
      this.segments.replaceChildren();
      this.slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.index = index;
        button.setAttribute('aria-controls', this.track.id);
        button.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
        this.segments.append(button);
      });
      this.go(Math.min(this.index, Math.max(0, this.slides.length - 1)));
    }
    go(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      const staticLayout = this.desktop.matches || (matchMedia('(max-width:749px)').matches && this.dataset.mobileCarousel === 'false');
      this.navigation.hidden = staticLayout || this.slides.length < 2;
      this.track.tabIndex = staticLayout ? -1 : 0;
      const left = this.slides[this.index] ? this.slides[this.index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft : 0;
      this.track.scrollTo({left: staticLayout ? 0 : left, behavior: 'instant'});
      this.update();
    }
    sync() {
      if (this.desktop.matches) return;
      if (this.dataset.mobileCarousel === 'false' && matchMedia('(max-width:749px)').matches) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max > 0 && this.track.scrollLeft >= max - 2) this.index = this.slides.length - 1;
      else {
        const start = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - start) < Math.abs(this.slides[best].getBoundingClientRect().left - start) ? i : best, 0);
      }
      this.update();
    }
    update() {
      Array.from(this.segments.children).forEach((button, index) => {
        button.setAttribute('aria-current', String(index === this.index));
      });
      this.querySelector('[data-direction="-1"]').disabled = this.index <= 0;
      this.querySelector('[data-direction="1"]').disabled = this.index >= this.slides.length - 1;
    }
  });
}
